<div id="player-container">
  <div id="player" 
    [class.visible]="(!inline && videoDisabled) ? false : ( (media && assetType != 'audio') || showPaywall )" 
    [class.fullscreen]="fullscreen" 
    [class.idle]="idle && !controlsAlwaysVisible" 
    [class.pip]="!fullscreen && !pipSuppressed && assetType != 'audio' && pip && !isPaywallAndInline"
    [class.idle-fast-transition]="fastIdleTransition"
    [class.has-sidebar]="hasSidebar && fullscreen" 
    [class.sw-keyboard-visible]="softwareKeyboardVisible"

    [attr.data-is-pip]="isPip"
    [attr.data-is-inline]="isInline">

    <!-- PAYWALL -->
    <div class="paywall" *ngIf="showPaywall">
      <tyt-paywall [noun]="videoLabel"></tyt-paywall>
    </div>
    <!-- /PAYWALL -->

    <div *ngIf="isPremium && !showPaywall && !isPip" class="plus-bug" [class.controls-visible]="!idle">
      <tyt-plus-tag></tyt-plus-tag>
    </div>

    <div id="playback-element" #playbackElement></div>
    
    <div class="notifier" [class.visible]="notifying">
      <div>{{notifyMessage}}</div>
    </div>

    <a class="big-play-container" *ngIf="enableControls && media && !hasPlayed" href="javascript:;" (click)="play()">
      <!-- <div class="big-play">
        <i class="fa fa-play" aria-hidden="true"></i>
      </div> -->

      <div class="btn-play">
        <i class="fas fa-play" aria-hidden="true"></i>
      </div>
    </a>

    <div class="buffering-container" *ngIf="displayBuffering">
      <app-spinner color="white"></app-spinner>
    </div>

    <ng-container *ngIf="enableControls">
      <div id="mini-overlay" *ngIf="isPip" (click)="miniClick()"></div>
      <a id="mini-go-true-fullscreen" href="javascript:;" *ngIf="isPip" (click)="goTrueFullscreen()" aria-label="Go full screen">
        <i class="fa fa-expand" aria-hidden="true"></i>
      </a> 
      <a id="mini-close" href="javascript:;" *ngIf="isPip && !fullscreen" (click)="hideOrDismiss()" aria-label="Dismiss media">
        <i class="fa fa-times" aria-hidden="true"></i>
      </a>
      <a id="mini-play" href="javascript:;" (click)="togglePlay()" *ngIf="isPip && !showPaywall" aria-label="Toggle media playback">
          <i *ngIf="playing" class="fa fa-pause" aria-hidden="true"></i>
          <i *ngIf="!playing" class="fa fa-play" aria-hidden="true"></i>
      </a>  
    </ng-container>

    <div *ngIf="enableControls" id="fullscreen-ui" [class.visible]="!(paywallVisible | async) && (fullscreen || !isPip)" class="d-flex">
      
      <div class="player-controls d-flex flex-column" (click)="showControlsClick()" 
        (doubleclick)="mouseDoubleClick()"
        (mousemove)="mouseMove()"
        (mousedown)="mouseDown()"
        (mouseleave)="mouseLeave()"
        (mouseenter)="mouseEnter()">
        <div class="c2a" [class.visible]="callingToAction">
          <div class="content" *ngIf="c2a">
            <div class="box link" *ngIf="c2a.type == 'url'">
              <a target="_blank" href="{{c2a.url}}">{{c2a.title}}</a><br/>
              {{c2a.message}}
            </div>
          </div>
        </div>
        <header *ngIf="isInline" class="d-flex flex-row fade-on-idle" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()">
          <div class="spacer"></div>
        </header>
        <header *ngIf="fullscreen" class="d-flex flex-row fade-on-idle" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()">

          <div id="close" (click)="showControlsClick()">
            <!-- <a class="dismiss" href="javascript:;" (click)="dismiss()" *ngIf="!isInline">
              <i class="fa fa-times" aria-hidden="true"></i>
            </a>  -->
            <a class="minimize" href="javascript:;" (click)="exitFullscreen(true)">
              <i class="fa fa-window-restore" aria-hidden="true"></i> Browse and Watch
            </a> 
          </div>
          <div class="spacer" (click)="toggleClick($event)">
          </div> 
          <a *ngIf="!hasSidebar" id="show-sidebar" href="javascript:;" (click)="showSidebar(); showControlsClick()">
            <i class="fa fa-bars" aria-hidden="true"></i>
          </a> 
        </header> 
        <div class="overlaid spacer" (click)="toggleClick($event)"></div>
        <div class="overlay"></div>
        <footer class="d-flex flex-row watermark" (click)="toggleClick($event)">
          <div class="spacer"></div>
        </footer>
        <tyt-player-banner
          *ngIf="this.user == null"
          class="player-banner"
          [isVodPremium]="isPremium"
          [productionId]="productionId"
          [vodId]="vodId"
          [customText]="bannerTopicCustomText">
        </tyt-player-banner>
        <footer id="controls" class="fade-on-idle d-flex flex-column" (mouseleave)="mouseLeave()" (mouseenter)="mouseEnter()" (click)="showControlsClick()"> 

          <player-seek-bar *ngIf="sessionSeekable" [seekPreviewValue]="seekPreviewValue" [isLive]="isLive" [duration]="length" [seekPosition]="seekPosition" (seekDrag)="seekPreviewTo($event)" (seek)="seekTo($event)"></player-seek-bar>
          <div class="controls-line">
            <a id="play" href="javascript:;" (click)="togglePlay()">
              <i *ngIf="playing" class="fa fa-pause" aria-hidden="true"></i>
              <i *ngIf="!playing" class="fa fa-play" aria-hidden="true"></i>
            </a>

            <a id="rewind-button" (click)="seekBack()">
              <i class="fa fa-undo" aria-hidden="true"></i>
            </a> 
            <a *ngIf="hasMoreQueueItems" id="next" (click)="skip()">
              <i class="fa fa-forward" aria-hidden="true"></i>
            </a>
            <player-volume-button [volume]="volume" (change)="setVolume($event)"></player-volume-button>
            <div class="spacer position">
              <ng-container *ngIf="isLive">
                -{{livePosition | duration: 'short-seconds' }}
              </ng-container>

              <ng-container *ngIf="!isLive">
                <ng-container *ngIf="seekPreviewFlag">
                  {{seekPreviewValue | duration: 'short-seconds'}}  
                </ng-container>
                <ng-container *ngIf="!seekPreviewFlag">
                  {{rawPosition | duration: 'short-seconds'}}
                </ng-container>
                
                / {{length | duration: 'short-seconds'}}
              </ng-container>
            </div>

            <a class="playback-rate" href="javascript:;" (click)="nextPlaybackRate()" *ngIf="session && session.supportedPlaybackSpeeds">
              {{speed}}x
            </a>
            <tyt-cast-button></tyt-cast-button>
            <tyt-airplay-button></tyt-airplay-button>

            <a *ngIf="!trueFullscreen" id="enter-true-fullscreen" href="javascript:;" (click)="goTrueFullscreen()">
              <i class="fa fa-expand" aria-hidden="true"></i>
            </a> 
            
            <a href="javascript:;" (click)="jumpToLive()" class="is-live" [class.rewinded]="isRewinded" *ngIf="isLive" title="When lit: You are watching live. When unlit: you are rewinded and watching DVR content.">
              <span class="dot"></span>
              LIVE
            </a>
          </div>
        </footer>
      </div>

      <aside>
        <div class="title d-flex flex-row">
          <a href="javascript:;" (click)="hideSidebar()" class="no-portrait">
            <i class="fa fa-times" aria-hidden="true"></i>
          </a>
          <div class="sections">
            <section-link *ngIf="!isLive" name="playlist" [(active)]="activeSection">Playlist</section-link>
            <section-link name="info" [(active)]="activeSection">About</section-link>
            <section-link name="comments" [(active)]="activeSection">Conversation</section-link>
            <section-link *ngIf="hasChat" name="chat" [(active)]="activeSection">Chat</section-link>
            <!--
            <section-link name="social" [(active)]="activeSection">Social</section-link>
            <section-link name="queue" [(active)]="activeSection">Queue</section-link>
            -->
          </div>
        </div>
        <div class="sectioned">
            <section id="section-playlist" [class.active]="activeSection === 'playlist'" *ngIf="media">
              <tyt-production-view 
                class="mini"
                [currentlyPlayingItem]="media"
                [production]="production" 
                [mode]="playlistID" 
                [playInline]="true" 
                [playRemote]="true" 
                [showImage]="false" 
                [showFeedTag]="true"
                (playClicked)="playItem($event, playlist)"></tyt-production-view>
            </section>
            <section id="section-info" [class.active]="activeSection == 'info'">
              <h1 *ngIf="media && media.title">{{media.title | summarize}}</h1>
              <summary *ngIf="media && media.description" [innerHTML]="media.description | newlinesToHtml | linksToHtml | trustHtml"></summary>
            </section>
            <section id="section-comments" [class.active]="activeSection == 'comments'">
              <tyt-comments *ngIf="loadComments" [identifier]="topicIdentifier"></tyt-comments>
            </section>
          <section id="section-queue" [class.active]="activeSection == 'queue'">
            <div *ngIf="!queue || queue.length == 0" style="margin-left: 2em;">
              <em>No items in your queue</em>
            </div>
            <queue-item *ngFor="let item of queue" [item]="item" [activeItem]="activeQueueItem"></queue-item>
          </section>
          <section id="section-chat" [class.active]="activeSection == 'chat'">
            <div style="flex-grow: 1;" *ngIf="isLive">
              <div *ngIf="!hasPlatformChat">
                Chat is currently unavailable.
              </div>
              <div *ngIf="hasPlatformChat" id="chat" [innerHTML]="platformChatEmbed" tabindex="-1">
              </div>
            </div>
            <div *ngIf="!isLive">
              No chat is available because this content is not live
            </div>
          </section>
          <section [class.active]="activeSection == 'social'">
            This is social!
          </section>
        </div>
      </aside>
    </div> 
  </div> 
</div>